import {DIALOG_TYPE, LayoutConfig} from '@spartacus/storefront';
import {
    UigTermsConditionsDialogComponent
} from '../components/uig-legal/uig-terms-conditions-dialog/uig-terms-conditions-dialog.component';

export const uigTermsConditionsDialogLayoutConfig: LayoutConfig = {
    launch: {
        TERMS_CONDITIONS: {
            inlineRoot: true,
            component: UigTermsConditionsDialogComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
    },
};
